import {
  brandSpecificStaticText,
  staticText,
  Translated,
} from '../../utils/translations/staticText';

// Presentational static strings owned by the renderer (CMS-1642, Module 4),
// mirroring how M3 PlanTierSelector owns its heading/subheading in the submodule
// rather than threading them from the fe-services wrapper. Only the purely
// presentational strings live here: the boolean "included" accessible name and
// the two horizontal-scroll affordance labels. Trip/period wording that the
// wrapper interpolates with the currency code (SGD / trip) stays wrapper-side.
//
// Block ships only on SingSaver (SG, EN) and MoneyHero (HK, EN + ZH-HK) per the
// epic. SingSaver has no ZH locale, so the default (`_`) covers it; MoneyHero
// overlays ZH on the same English defaults. The `zh` key resolves for a `zh-hk`
// context via the 2-char locale fallback in `resolveLocale` (exact → 2-char →
// `_`), matching M3.
export const TRANSLATIONS = brandSpecificStaticText({
  _: staticText({
    included: { _: 'Included' },
    scrollLeft: { _: 'Scroll table left' },
    scrollRight: { _: 'Scroll table right' },
  }),
  moneyhero: staticText({
    included: { _: 'Included', zh: '已包含' },
    scrollLeft: { _: 'Scroll table left', zh: '向左捲動表格' },
    scrollRight: { _: 'Scroll table right', zh: '向右捲動表格' },
  }),
});

export type StaticText = Translated<typeof TRANSLATIONS>;
